<template>
    <div class="grid-content">
        <div class="box-filter">
            <el-form ref="ruleForm" @submit.prevent v-on:submit.prevent>
                <div class="viewFilter">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" style="position:relative;">
                            <el-form-item prop="periodo_credenciamento" label="Data de Cadastro">
                                <el-date-picker 
                                    format="dd/MM/yyyy" 
                                    value-format="yyyy-MM-dd" 
                                    style="width: 100%" 
                                    v-model="ruleForm.periodo_credenciamento" 
                                    type="daterange" 
                                    @handleValue="(x) => { ruleForm.periodo_credenciamento = x; this.filterFields(); }" 
                                    start-placeholder="Inicio" end-placeholder="Fim"
                                    @change="filterFields"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-form-item prop="marketplace_id" label="Marketplace">
                                <SelectSearchMarketplace 
                                    :model="ruleForm.marketplace_id" 
                                    :isEdit="false"
                                    @handleValue="(x) => { ruleForm.marketplace_id = x; this.filterFields(); }"
                                    @change="filterFields"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-form-item prop="agent_id" label="Representante">
                                <SelectSearchRepresentante
                                    :model="ruleForm.agent_id"
                                    :isEdit="false" 
                                    @handleValue="(x) => { ruleForm.agent_id = x; this.filterFields(); }"
                                    @change="filterFields"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-form-item prop="department_store_id" label="Estabelecimento Comercial">
                                <SelectSearchDepartamentStore 
                                    :model="ruleForm.department_store_id" 
                                    :isEdit="false" 
                                    @handleValue="(x) => { ruleForm.department_store_id = x; this.filterFields(); }"
                                    @change="filterFields"
                                />
                            </el-form-item>
                        </el-col>
                        <!--
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" style="position:relative;">
                            <el-form-item prop="min_venda" label="Valor mínimo de vendas">
                                <el-input 
                                    v-model="ruleForm.min_venda"
                                    @handleValue="(x) => { ruleForm.agent_id = x; this.filterFields(); }"
                                    @change="filterFields" />
                            </el-form-item>
                        </el-col>
                        -->
                        <el-col :xs="24" :sm="12" :md="4" :lg="8" :xl="5" >
                            <el-form-item prop="button">
                                <el-button-group>
                                    <el-button
                                        @click="filterFields('export')"
                                        type="success"
                                        size="large"
                                    >
                                    Exportar Lista!
                                    </el-button>
                                    <el-button
                                        @click="clearSearch()"
                                        type="default"
                                        size="large"
                                    >
                                    Limpar Filtros
                                    </el-button>
                                </el-button-group>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="2">
                            <el-form-item prop="button">
                                
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>
        <div class="grid-content">
            <el-row class="LinhaSetas">
                <Quadro 
                    status_text="Não Ativados"
                    :ammount="countStatus.inactive" 
                    status_class="inativo"
                    filter_status="inactive"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus" />
                <Quadro 
                    status_text="Ativados"
                    :ammount="countStatus.active" 
                    status_class="ativo"
                    filter_status="active"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus" />
            </el-row>
        </div>
    </div>
</template>

<script>
    import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
    import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante";
    import Quadro from "@/app/components/Activation/Quadro";
    import SelectSearchDepartamentStore from "@/app/components/EstabelecimentoComercial/SelectSearchDepartamentStore";

    export default {
        name: "FilterBox",
        props: ["countStatus", "total"],
        components: {
            SelectSearchMarketplace,
            SelectSearchRepresentante,
            Quadro,
            SelectSearchDepartamentStore,
        },
        data() {
            const data_atual = new Date();
            var data_inicio = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-01';
            var data_fim = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-' + data_atual.getDate();
            return {
                query: "?activation=1",
                loadingPage: true,
                ruleForm: {
                    periodo_credenciamento: [data_inicio, data_fim],
                    marketplace_id: null,
                    agent_id: null,
                    min_venda: null,
                    status: [],
                    department_store_id: null,
                }
            };
        },
        methods: {
            clearSearch() {
                const data_atual = new Date();
                var data_inicio = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-01';
                var data_fim = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-' + data_atual.getDate();

                this.query = "?activation=1";
                this.ruleForm.periodo_credenciamento = [data_inicio, data_fim];
                this.ruleForm.marketplace_id = null;
                this.ruleForm.agent_id = null;
                this.ruleForm.min_venda = null;
                this.ruleForm.status = [];
                this.department_store_id = null;
                this.filterFields();
            },
            setStatus(status) {
                if(this.ruleForm.status.includes(status)) {
                    this.ruleForm.status = this.ruleForm.status.filter(status_item => status_item !== status);
                } else {
                    this.ruleForm.status.push(status)
                }
                this.filterFields('status');
            },
            filterFields(searchMethod) {
                this.query = `?activation=1`;
                if (this.ruleForm.periodo_credenciamento) {
                    this.query = `${this.query}&periodo_credenciamento=${this.ruleForm.periodo_credenciamento}`;
                }
                if (this.ruleForm.marketplace_id) {
                    this.query = `${this.query}&marketplace_id=${this.ruleForm.marketplace_id}`;
                }
                if (this.ruleForm.agent_id) {
                    this.query = `${this.query}&agent_id=${this.ruleForm.agent_id}`;
                }
                if (this.ruleForm.department_store_id) {
                    this.query = `${this.query}&department_store_id=${this.ruleForm.department_store_id}`;
                }
                // if (this.ruleForm.min_venda) {
                //     this.query = `${this.query}&min_venda=${this.ruleForm.min_venda}`;
                // }
                if (searchMethod == 'export' || searchMethod == 'status') {
                    if (this.ruleForm.status.length >= 1) {
                        this.query = `${this.query}&status=${this.ruleForm.status}`;
                    }
                }
                if(searchMethod == 'export') {
                    this.$emit("filterExport", this.query);
                } else if (searchMethod == 'status') {
                    this.$emit("filterStatus", this.ruleForm);
                } else {
                    this.$emit("filterList", this.query);
                }
            }
        }
    };
</script>

<style scoped>
    @media only screen and (min-width: 767px) {
        .LinhaSetas {
            justify-content: center;
            display: flex;
        }
    }
</style>